<div class="pr-4 pl-2 pageheader">
  <div class="float-left mt-3">
    <h5 class="float-left">Add Requisition Exception</h5>
  </div>
  <div class="float-right">
    <button (click)="saveRequisitionException()" class="m-2"><i class="fa fa-save"></i> Save</button>
    <button class="m-2" [routerLink]="['/requisitionException-list']"><i class="fa fa-times"></i> Cancel</button>
  </div>
</div>

<p-fieldset legend="Exception Details">
  <div class="row">
    <div class="col-6">
      {{Id}}
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <div class="row">
        <div class="col m-2">
          <label for="requisition" class="toplabel">Requisition </label><br />
          <p-select [options]="requisitions" [(ngModel)]="requisitionException.RequisitionId" [style]="{'width':'100%'}"></p-select>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col m-2">
          <span class="ui-float-label">
            <input id="issueDescription" type="text" size="200" [(ngModel)]="requisitionException.IssueDescription" pInputText>
            <label for="issueDescription">Issue Description</label>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="row">
        <div class="col m-2">
          <label for="assignedTo" class="toplabel">Assigned To</label><br />
          <p-select [options]="assignedTos" [(ngModel)]="requisitionException.AssignedTo" [style]="{'width':'100%'}"></p-select>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col m-2">
          <label for="assignedDate" class="toplabel">Date Assigned</label><br />
          <p-datepicker id="assignedDate" [(ngModel)]="requisitionException.AssignedDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"></p-datepicker>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col m-2">
          <span class="ui-float-label">
            <input id="resolutionDescription" type="text" size="200" [(ngModel)]="requisitionException.ResolutionDescription" pInputText>
            <label for="resolutionDescription">Resolution Description</label>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-2"> 
      <div class="row">
        <div class="col m-2">
          <label for="resolved" class="toplabel">Resolved</label><br />
          <input id="resolved" type="checkbox" size="20" [(ngModel)]="requisitionException.Resolved">
        </div> 
      </div>
    </div>
    <div class="col-4">
      <div class="row">
        <div class="col m-2">
          <label for="resolvers" class="toplabel">Resolved By</label><br />
          <p-select [options]="resolvers" [(ngModel)]="requisitionException.ResolvedBy" [style]="{'width':'100%'}"></p-select>
        </div>
      </div>
    </div>
    <div class="col-2">
      <div class="row">
        <div class="col m-2">
          <label for="resolvedDate" class="toplabel">Date Resolved</label><br />
          <p-datepicker id="resolvedDate" [style]="{'width':'100%'}" [(ngModel)]="requisitionException.ResolvedDate" [inputStyle]="{'width':'100%'}"></p-datepicker>
        </div>
      </div>
    </div>
  </div>
</p-fieldset>
